import styled, { css } from "styled-components";


export const ThinText = styled.h4`
    font-weight: 300
`
